import { FC } from 'react';
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';

interface YandexCaptchaProps {
  sitekey: string;
  visible: boolean;
  onSuccess: (token: string) => void;
  onChallengeHidden?: () => void;
}

export const YandexCaptcha: FC<YandexCaptchaProps> = ({ sitekey, visible, onSuccess, onChallengeHidden }) => (
  <div
    style={{
      position: 'absolute',
      width: 0,
      height: 0,
    }}
  >
    <InvisibleSmartCaptcha
      sitekey={sitekey}
      visible={visible}
      onSuccess={onSuccess}
      onChallengeHidden={onChallengeHidden}
    />
  </div>
);
